/** The default auth modal options. */
const DEFAULT_AUTH_MODAL_OPTIONS = {
    title: 'Midway session expired',
    body: 'Your Midway session has expired. Please click the below button to authenticate.',
    buttonText: 'Authenticate'
};
/** Creates the default auth modal. */
export const createDefaultModal = options => {
    const modal = document.createElement('div');
    modal.style.cssText = 'align-items: center; background-color: rgba(0,0,0,0.8); display: flex; min-height:100%; font: 16px sans-serif; min-width:100%; left: 0; position:absolute; top: 0; z-index: 2147483647;';
    modal.innerHTML = '<div style="background-color: #fff; margin-left:auto; margin-right:auto; padding-bottom: 15px; text-align: center; width: 400px;">\
    <div class="title" style="padding: 8px; background-color:#fbb125; color:#fff; text-align:left"></div>\
    <div class="body" style="padding: 15px"></div>\
    <button style="background-color: #fbb125; border: 1px solid #996633; color: #fff; padding: 5px 12px;"></button>\
    </div>';
    // set button click event
    const button = modal.querySelector('button');
    button.addEventListener('click', options.openAuthWindow);
    // set text
    const { title, body, buttonText } = Object.assign(Object.assign({}, DEFAULT_AUTH_MODAL_OPTIONS), options);
    modal.querySelector('.title').textContent = title;
    modal.querySelector('.body').textContent = body;
    button.textContent = buttonText;
    document.body.appendChild(modal);
    return {
        close: () => {
            button.removeEventListener('click', options.openAuthWindow);
            modal.remove();
        }
    };
};
